module.exports = {"430406001":"先锋街道","430406002":"雁峰街道","430406003":"天马山街道","430406004":"黄茶岭街道","430406005":"白沙洲街道","430406100":"岳屏镇","430406400":"白沙洲工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430406.json
// module id = 1834
// module chunks = 0